import { render, staticRenderFns } from "./printHistoriaAdolescente.vue?vue&type=template&id=73e50dab&scoped=true&"
import script from "./printHistoriaAdolescente.vue?vue&type=script&lang=js&"
export * from "./printHistoriaAdolescente.vue?vue&type=script&lang=js&"
import style0 from "./printHistoriaAdolescente.vue?vue&type=style&index=0&id=73e50dab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e50dab",
  null
  
)

export default component.exports